import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  AfterViewInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { UUID } from "angular2-uuid";
import { CropDataTool } from "../shared/classes/cropdatatoolModel";
import { WINDmodel } from "../shared/classes/windModel";
import { Activity } from "../shared/classes/activityModel";
import { Practice } from "../shared/classes/practiceModel";
import { POP } from "../shared/classes/popModel";
import { CropData } from "../shared/classes/cropdataModel";
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";
import { IndividualHealth } from "../shared/classes/individualHealthModel";
import { AuthenticateService } from "../shared/services/authenticate.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { CropsService } from "../shared/services/crops.service";
import { ProfileService } from "../shared/services/profile.service";
import { FileUploadService } from "src/app/shared/services/fileupload.service";
import { TokenStorageService } from "../shared/services/token.service";

declare var require: any;

const now = new Date();

@Component({
  selector: "app-agritool",
  templateUrl: "./agritool.component.html",
  styleUrls: ["./agritool.component.sass"],
  styles: [
    `
    .custom-day {
      text-align: center;
      padding: 0.185rem 0.25rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
    }
    .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after{
      background-color: #3ac47d;
    }
    .custom-day.focused {
      background-color: #e6e6e6;
    }
    .custom-day.range, .custom-day:hover {
      background-color: rgb(2, 117, 216);
      color: white;
    }
    .custom-day.faded {
      background-color: rgba(2, 117, 216, 0.5);
    }
    ::ng-deep.mat-horizontal-stepper-header{
      pointer-events: none;
     }
    ::ng-deep .mat-step-header .mat-step-icon {
    background-color: MediumSeaGreen; 
 }
  `,
  ],
})
export class AgritoolComponent implements OnInit, AfterViewInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  show: boolean = false;
  mainprofileArray = [];
  closeResult: string;
  numberOfVisits: number;
  type: string = "save";

  @ViewChild("ngxLoading") ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild("customLoadingTemplate") customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  fobj: {
    group: string;
    profileId: string;
    maincropId: string;
    cropId: string;
    categoryId: string;
    cropImages: any[];
    varietyImages: any[];
    numberOfVisits: number;
    cropCategory: string;
    cropName: string;
    varietyName: string;
    hybridName: string;
    cropType: string;
    duration: number;
    varietyCode: string;
    hybridCode: string;
    cropDescription: string;
    endProductDescription: string;
    collectionData: any[];
    status: string;
  };
  public loading: boolean;
  sobj: {};
  iobj: {
    product: string;
    productuuid: string;
    application: string;
    dosage: string;
    info: string;
    image: any[];
    video: string;
  };
  dobj: {
    product: string;
    productuuid: string;
    application: string;
    dosage: string;
    info: string;
    image: any[];
    video: string;
  };
  wobj: {
    product: string;
    productuuid: string;
    application: string;
    dosage: string;
    info: string;
    image: any[];
    video: string;
  };
  nobj: {
    product: string;
    productuuid: string;
    application: string;
    dosage: string;
    info: string;
    image: any[];
    video: string;
  };
  aobj: { application: string; image: any[]; video: string };
  pobj: { practice: string; image: any[]; video: string };
  healthObj: {
    name: string;
    healthId: string;
    cropName: string;
    description: string;
    images: any[];
    recommLow: string;
    recommMedium: string;
    recommHigh: string;
    group: string;
  };
  editHealth: any[] = [];
  insectArray: any[];
  diseaseArray: any[];
  weedArray: any[];
  nutritionArray: any[];
  activityArray: any[];
  practiceArray: any[];
  showIList: boolean = true;
  showDList: boolean = true;
  showWList: boolean = true;
  showNList: boolean = true;
  showAList: boolean = true;
  showPList: boolean = true;
  showHList: boolean = true;
  scheduledVisitNumber: number[] = [];
  tolerance: number[] = [];
  scheduledVisitName: string[] = [];
  imageUploadService: string;
  model: NgbDateStruct;
  assessmentArray: {}[];
  settings: {};
  healthArray: any[];
  popIndex: any;
  imageNameList = [];
  healthDiagnosisIndex: any;
  cropIndex: any;
  cropNameList: Array<string> = [];
  insectText: boolean = false;
  diseaseText: boolean = false;
  weedText: boolean = false;
  nutritionText: boolean = false;
  insectInstruction: any;
  diseaseInstruction: any;
  weedInstruction: any;
  nutritionInstruction: any;
  cropFormGroup: FormGroup;
  cropDataTool: CropDataTool;
  urls = [];
  profileUuid: string;
  popCollection = [];
  cropDataCollection = [];
  healthId: string;
  hobj: { healthId: string; healthData: any[] };
  globalImgUrl: string = this.authService.s3url();
  healthdiagnosis: any;
  wind: WINDmodel;
  practice: Practice;
  activity: Activity;
  pop: POP[];
  cropdata: CropData[];
  healthDiagnosisFormGroup: FormGroup;
  healthdiagnosisArray: any[];
  mainCropID: any;
  cropDataGroup: FormGroup;
  qtnAnsArray: any[];
  editRow: any[] = [];
  cropdataObj: {
    orderId: number;
    ask: string;
    type: string;
    response: string;
    kpi: boolean;
  };
  cropdataUpdateObj: {
    orderId: number;
    ask: string;
    type: string;
    response: string;
    kpi: boolean;
  };
  kpiName: string;
  showKpiName: boolean = false;
  productList: any[];
  cropID: any;
  categoryId: any;
  showmlist: boolean = true;
  healthDiagnosisGroup: FormGroup;
  individualHealth: IndividualHealth;
  groupName: string;
  varietyArray = [];
  showStepper: string = "crops";
  loadingcrops: boolean;
  insectImgList = [];
  diseaseImgList = [];
  weedImgList = [];
  nutritionImgList = [];
  activityImgList = [];
  practiceImgList = [];
  poptype: string = "save";
  videoUrl = "";
  videoList = [];
  videoArray = [];
  popindex: number;
  fetchedToolList = [];
  dataId: string;
  popId: string;
  healthRowId: string;
  finalBtntype: string = "save";
  popBtnColor = [];
  cropDataBtnColor = [];
  healthBtnColor = [];
  uploadFileList: any[] = [];
  videoName: string = "";
  windGroup: FormGroup;
  checkList: any[] = [];
  tempObject: any;
  popApplication: string = "";
  popProduct: string = "";
  popDosage: string = "";
  popPractice: string = "";
  dataSubmitingload: boolean = false;
  previousPage: number;
  skip: number;
  collectionSize: any;
  page = 1;
  searchStr: string = "";
  showsearchdata: boolean = true;
  showTable: boolean = false;
  harvestForm: FormGroup;
  harvestObj: { parameter: string; possibleValues: string; type: string };
  harvestArray: any = [];
  editHarvestRow: any[] = [];
  editHarvestObj: any = {};
  readOnly: boolean = true;
  rowReadOnly: any[] = [];
  sampling: string = "";
  showHealthForms: boolean = false;
  transportObj: any = {};
  transportForm: FormGroup;
  subTypeArray: any = [];
  showTransportTable: boolean = false;
  transportArray: any = [];
  editTransportRow: any[] = [];
  editTransportObj: any = {};
  dropdownSettings: {
    singleSelection: boolean;
    defaultOpen: boolean;
    idField: string;
    textField: string;
    selectAllText: string;
    unSelectAllText: string;
    enableCheckAll: boolean;
    itemsShowLimit: number;
    allowSearchFilter: boolean;
    maxHeight: number;
  };
  healthdiagnosisList: any = [];
  healthCollectionSize: any;
  healthSkip: number;
  healthPreviousPage: number;
  packingTypeArray: any = [];
  packageArray: any = [];
  unitForm: FormGroup;
  unitObj: any = {};
  unitsArray: any = [];
  editUnitRow: any[] = [];
  editUnitObj: any = {};
  showUnits: boolean = false;
  healthIdList: any[];
  selectedCrop: any;
  componentData = undefined;
  constructor(
    private _formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private modalService: NgbModal,
    private cropsService: CropsService,
    private profileService: ProfileService,
    private tokenService: TokenStorageService,
    private fileUploadService: FileUploadService
  ) { }

  ngOnInit() {
    this.globalImgUrl = this.authService.s3url();
    this.groupName = this.tokenService.getGroup();
    this.getAllProducts();
    this.packingTypeArray = [];
    this.packageArray = require("../shared/definedJsons/packageObj.json");
    for (let i = 0; i < this.packageArray.length; i++) {
      this.packingTypeArray = this.packingTypeArray.concat(
        this.packageArray[i].packingType
      );
    }
    this.dropdownSettings = {
      singleSelection: false,
      defaultOpen: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      maxHeight: 70,
    };
    // console.log("this.authService.getUserDetails on init", this.groupName, this.cropdata);
    this.windGroup = this._formBuilder.group({
      product: ["", Validators.required],
      dosage: ["", Validators.required],
      application: ["", Validators.required],
    });
    this.cropdata = [];
    this.healthdiagnosis = [];
    this.mainprofileArray = [];
    this.popBtnColor = [];
    this.cropDataBtnColor = [];
    this.healthBtnColor = [];
    this.pop = [];
    this.popIndex = null;
    this.cropDataGroup = this._formBuilder.group({
      orderId: ["", Validators.required],
      ask: ["", Validators.required],
      type: ["", Validators.required],
      response: ["", Validators.required],
      kpi: ["", Validators.required],
      kpiName: [""],
    });
    this.harvestForm = this._formBuilder.group({
      parameter: ["", Validators.required],
      type: ["", Validators.required],
    });
    this.transportForm = this._formBuilder.group({
      packingType: ["", Validators.required],
      subType: ["", Validators.required],
      packingDescription: ["", Validators.required],
    });
    this.unitForm = this._formBuilder.group({
      unit: ["", Validators.required],
      quantity: ["", Validators.required],
    });
    this.harvestObj = {
      parameter: "",
      possibleValues: "",
      type: "",
    };
    this.fobj = {
      group: "",
      profileId: "",
      maincropId: "",
      categoryId: "",
      cropId: "",
      cropImages: [],
      varietyImages: [],
      numberOfVisits: 0,
      cropCategory: "",
      cropName: "",
      varietyName: "",
      hybridName: "",
      cropType: "",
      duration: 0,
      varietyCode: "",
      hybridCode: "",
      cropDescription: "",
      endProductDescription: "",
      collectionData: [],
      status: "",
    };
    this.cropFormGroup = this._formBuilder.group({
      cropCategory: ["", Validators.required],
      varietyName: ["", Validators.required],
      hybridName: [""],
      cropname: ["", Validators.required],
      varietyCode: ["", Validators.required],
      hybridCode: [""],
      cropType: ["", Validators.required],
      duration: ["", Validators.required],
      cropDescription: [""],
      endProductDescription: [""],
    });
    this.healthDiagnosisFormGroup = this._formBuilder.group({
      recommLow: ["", Validators.required],
      recommMedium: ["", Validators.required],
      recommHigh: ["", Validators.required],
    });
    this.healthDiagnosisGroup = this._formBuilder.group({
      name: ["", Validators.required],
      cropName: ["", Validators.required],
      description: ["", Validators.required],
      recommLow: ["", Validators.required],
      recommMedium: ["", Validators.required],
      recommHigh: ["", Validators.required],
    });
  }

  ngAfterViewInit() { }
  //technical name add
  config = {
    // displayKey: 'tradeName', // if objects array passed which key to be displayed defaults to description
    displayKey: "technicalName",
    search: true,
    limitTo: 100,
    height: "225px",
  };

  subconfig = {
    // displayKey: 'productName', // if objects array passed which key to be displayed defaults to description
    search: true,
    limitTo: 100,
    height: "225px",
  };
  onProductChange(e, type) {
    // console.log("@@On product change:", e,"@Type:",type);
    // console.log("@@Pop product:",this.popProduct);
  }
  //get All  varieties
  // getAllVarieties() {
  //   this.showsearchdata = true;
  //   this.varietyArray = [];
  //   this.loadingcrops = true;
  //   var count = { match: { group: this.groupName } }
  //   this.cropService.getVarietycount(count).then((data: any) => {
  //     console.log("COUNT : ", data);
  //     if (data.length > 0) {
  //       this.collectionSize = data[0].size
  //       var options = {
  //         group: this.groupName,
  //         options: {
  //           limit: 20,
  //           sortFields: { createTs: -1 },
  //           skip: 0
  //         }
  //       }
  //       this.varietyArray = [];
  //       this.cropService.getAllCropsVariety(options).then((data: any) => {
  //         console.log("cropData == ", data);
  //         if (data.length > 0) {
  //           this.varietyArray = data;
  //           console.log("varietyarray", this.varietyArray)
  //           this.loadingcrops = false;
  //         } else {
  //           this.loadingcrops = false;
  //         }
  //       })
  //     } else {
  //       this.loadingcrops = false;
  //     }
  //   });
  // }

  // loadData(skip) {
  //   var count = { match: { group: this.groupName } }
  //   this.cropService.getVarietycount(count).then((data: any) => {
  //     console.log("Demand size : ", data)
  //     if (data.length > 0) {
  //       this.collectionSize = data[0].size
  //       console.log("collectionsize", this.collectionSize)
  //       var options = {
  //         group: this.groupName,
  //         options: {
  //           limit: 20,
  //           sortFields: { createTs: -1 },
  //           skip: skip
  //         }
  //       }
  //       this.cropService.getAllCropsVariety(options).then((data: any) => {
  //         console.log("getDemandCount : ", data);
  //         if (data.length > 0) {
  //           this.varietyArray = data;
  //           this.loading = false;
  //         } else {
  //           this.loading = false;
  //         }
  //       });
  //     } else {
  //       this.loading = false;
  //     }
  //   });
  // }

  // loadPage(pageNumber: number) {
  //   this.loading = true;
  //   console.log("page number ", pageNumber, this.previousPage)
  //   if (pageNumber !== this.previousPage) {
  //     this.skip = (pageNumber * 20) - 20;
  //     this.previousPage = pageNumber;
  //     this.loadData(this.skip);
  //   }
  // }

  getVarietiesByCrop(skip, crop) {
    this.loadingcrops = true;
    this.selectedCrop = crop;
    this.showStepper = "varieties";
    this.showsearchdata = true;
    this.varietyArray = [];
    var options = {
      group: this.groupName,
      maincropId: crop.maincropId,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // },
    };
    this.cropsService.getCropVarieties(options).then((data: any) => {
      // console.log("cropData == ", data);
      if (data.length > 0) {
        this.varietyArray = data;
        // console.log("varietyarray", this.varietyArray)
        this.loadingcrops = false;
      } else {
        this.loadingcrops = false;
      }
    });
    var count = { group: this.groupName, maincropId: crop.maincropId };
    // console.log("COUNT obj: ", count);
    this.cropsService.getCropVarietiesCount(count).then((data: any) => {
      // console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    // console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = pageNumber * 20 - 20;
      this.previousPage = pageNumber;
      this.getVarietiesByCrop(this.skip, this.selectedCrop);
    }
  }

  backToCrops() {
    this.showStepper = "crops";
    console.log("@@Coming to back to crops", this.showStepper);
  }

  //open data steps
  openStepper(variety) {
    console.log(variety);
    this.getToolData(variety);
    this.insectImgList = [];
    this.diseaseImgList = [];
    this.weedImgList = [];
    this.nutritionImgList = [];
    this.activityImgList = [];
    this.practiceImgList = [];
    // this.showStepper = !this.showStepper;
    this.showStepper = "addProfileDef";
  }

  getToolData(variety) {
    this.fobj = {
      group: "",
      profileId: "",
      maincropId: "",
      categoryId: "",
      cropId: "",
      numberOfVisits: 0,
      cropImages: [],
      varietyImages: [],
      cropCategory: "",
      cropName: "",
      varietyName: "",
      hybridName: "",
      cropType: "",
      duration: 0,
      varietyCode: "",
      hybridCode: "",
      cropDescription: "",
      endProductDescription: "",
      collectionData: [],
      status: "",
    };
    this.cropFormGroup.reset();
    var varietyobj = {
      cropId: variety.cropId,
      maincropId: variety.maincropId,
      group: this.groupName,
    };
    var cropobj = {
      maincropId: variety.maincropId,
      group: this.groupName,
    };
    // console.log("variety = ", variety);
    this.fetchedToolList = [];
    this.harvestArray = [];
    this.transportArray = [];
    this.unitsArray = [];
    this.sampling = "";
    this.cropsService.getCropData(cropobj).then((cropdata: any) => {
      if (cropdata.length > 0) {
        this.fobj.cropImages = cropdata[0].cropImages;
        this.fobj.cropName = cropdata[0].cropName;
      } else {
        this.fobj.cropImages = [];
      }
    });
    this.profileService.getTooldata(varietyobj).then((data: any) => {
      // console.log("getTooldata = ", data);
      if (data.length > 0) {
        this.fetchedToolList = data;
        this.mainCropID = variety.maincropId;
        this.cropID = variety.cropId;
        this.categoryId = variety.categoryId;
        if (data[0].harvestData) {
          this.harvestArray = data[0].harvestData["harvestParams"];
          for (let i = 0; i < this.harvestArray.length; i++) {
            if (this.harvestArray[i].possibleValuesArray) {
              this.harvestArray[i].possibleValues = this.harvestArray[
                i
              ].possibleValuesArray
                .map((item) => item)
                .join(",");
            }
            // console.log("possibleValues", this.harvestArray.possibleValues);
          }
          // console.log("harvestArray", this.harvestArray);
          this.showTable = true;
          this.sampling = data[0].harvestData.sampling;
        }
        if (data[0].transportData) {
          this.transportArray = data[0].transportData;
          // console.log("transportArray", this.transportArray);
          this.showTransportTable = true;
        }
        if (data[0].packingSizes) {
          this.unitsArray = data[0].packingSizes;
          // console.log("unitsArray", this.unitsArray);
          this.showUnits = true;
        }
        this.fobj.varietyName = variety.varietyName;
        this.fobj.hybridName = variety.hybridName;
        this.fobj.cropType = variety.cropType;
        this.fobj.duration = variety.duration;
        this.fobj.cropImages = variety.cropImages;
        this.fobj.varietyCode = variety.varietyCode;
        this.fobj.hybridCode = variety.hybridCode;
        this.fobj.cropCategory = variety.cropCategory;
        this.fobj.varietyImages = variety.cropImages;
        // this.fobj.cropName = variety.cropName
        this.fobj.cropDescription = data[0].cropDescription;
        this.fobj.endProductDescription = data[0].endProductDescription;
        this.numberOfVisits = data[0].collectionData.length;
        this.profileUuid = data[0].profileId;
        this.finalBtntype = "update";
      } else {
        // if (data[0].harvestData) {
        //   this.harvestArray = data[0].harvestData['harvestParams'];
        //   for (let i = 0; i < this.harvestArray.length; i++) {
        //     this.harvestArray[i].possibleValues = this.harvestArray[i].possibleValuesArray.map(item => item).join(",");
        //     console.log("possibleValues", this.harvestArray.possibleValues);
        //   }
        //   this.showTable = false;
        //   this.sampling = data[0].harvestData.sampling;
        // }
        this.mainCropID = variety.maincropId;
        this.cropID = variety.cropId;
        this.categoryId = variety.categoryId;
        this.fobj.varietyName = variety.varietyName;
        this.fobj.hybridName = variety.hybridName;
        this.fobj.cropType = variety.cropType;
        this.fobj.duration = variety.duration;
        this.fobj.varietyCode = variety.varietyCode;
        this.fobj.hybridCode = variety.hybridCode;
        this.fobj.cropCategory = variety.cropCategory;
        this.fobj.cropImages = variety.cropImages;
        this.fobj.varietyImages = variety.cropImages;
        this.fobj.cropName = variety.cropName;
        this.profileUuid = undefined;
        this.numberOfVisits = 0;
        this.finalBtntype = "save";
      }
    });
  }

  backToVarieties() {
    // this.showStepper = !this.showStepper;
    this.showStepper = "varieties";
    this.getVarietiesByCrop(0, this.selectedCrop);
  }

  //save crop details #first page
  cropDetailsave() {
    for (let i = 0; i < this.harvestArray.length; i++) {
      delete this.harvestArray[i].possibleValues;
      this.harvestArray[i].orderId = i + 1;
      if (this.harvestArray[i].type == "Textbox") {
        delete this.harvestArray[i].possibleValuesArray;
      }
    }
    let harvestData = {
      harvestParams: this.harvestArray,
      sampling: this.sampling,
    };
    // console.log("harvest Data : ", JSON.stringify(harvestData));
    this.popBtnColor = [];
    this.cropDataBtnColor = [];
    this.healthBtnColor = [];
    this.sampling = "";
    this.harvestArray = [];
    if (this.profileUuid == undefined) {
      this.profileUuid = UUID.UUID();
    }
    this.fobj.group = this.groupName;
    this.fobj.profileId = this.profileUuid;
    this.fobj.categoryId = this.categoryId;
    this.fobj.cropId = this.cropID;
    this.fobj.maincropId = this.mainCropID;
    this.fobj["harvestData"] = harvestData;
    this.fobj["transportData"] = this.transportArray;
    this.fobj["packingSizes"] = this.unitsArray;
    // this.fobj.cropId = this.profileUuid;
    this.cropDataTool = this.fobj;
    // console.log("fobj Data : ", this.fobj);
    // console.log("transportArray Data : ", this.transportArray);
    // console.log("transportArray Data : ", JSON.stringify(this.transportArray));
    this.createVisits(this.numberOfVisits);
    // console.log("Crop details result #first page : ", JSON.stringify(this.cropDataTool));
  }

  // save scheduled visit #second page
  saveVisitpage() {
    // console.log("scheduledVisitNumber ", this.scheduledVisitNumber);
    for (var i = 0; i < this.scheduledVisitNumber.length; i++) {
      this.mainprofileArray[i]["scheduledVisitName"] =
        this.scheduledVisitName[i];
      this.mainprofileArray[i]["scheduledVisitDay"] =
        this.scheduledVisitNumber[i];
      this.mainprofileArray[i]["tolerance"] = this.tolerance[i];
    }
    // console.log("visit array #second page : ", this.mainprofileArray);
  }

  //create visits #click add button
  createVisits(count) {
    for (var c = 0; c < count; c++) {
      this.popBtnColor[c] = false;
      this.healthBtnColor[c] = false;
      this.cropDataBtnColor[c] = false;
    }
    // console.log("visits ", this.fetchedToolList, count);
    // this.numberOfVisits = count;
    this.fobj.numberOfVisits = this.numberOfVisits;
    this.mainprofileArray = [];
    this.scheduledVisitNumber = [];
    this.scheduledVisitName = [];
    this.tolerance = [];
    var value = 0;
    if (this.fetchedToolList.length > 0) {
      value = this.fetchedToolList[0].collectionData.length;
    } else {
      value = 0;
    }
    if (value > 0) {
      this.fetchedToolList[0].collectionData.forEach((element, index) => {
        // console.log("index ", index)
        if (element.cropDataId == "") {
          this.cropDataBtnColor[index] = false;
        } else {
          this.cropDataBtnColor[index] = true;
        }
        if (element.popId == "") {
          this.popBtnColor[index] = false;
        } else {
          this.popBtnColor[index] = true;
        }
        if (element.healthDiagnosisId == "") {
          this.healthBtnColor[index] = false;
        } else {
          this.healthBtnColor[index] = true;
        }
        this.mainprofileArray.push(element);
        this.scheduledVisitNumber.push(element.scheduledVisitDay);
        this.scheduledVisitName.push(element.scheduledVisitName);
        this.tolerance.push(element.tolerance);
      });
    }
    for (var i = value; i < count; i++) {
      let obj = {
        orderId: i,
        popId: "",
        cropDataId: "",
        healthDiagnosisId: "",
      };
      this.mainprofileArray.push(obj);
    }
    this.show = true;
    // console.log("mainprofileArray : ", this.mainprofileArray);
  }

  selectType(type) {
    console.log("type", type);
    this.readOnly = type == "Textbox" ? true : false;
  }

  selectPackingType(packingType) {
    this.subTypeArray = [];
    this.transportObj.subType = [];
    this.transportObj["subType"] = [];
    this.transportObj["subType"] = null;
    this.transportObj["subType"] = undefined;
    this.transportObj.subType = null;
    this.transportObj.subType = undefined;
    // console.log("packingType", packingType);
    this.subTypeArray = this.packageArray.filter(
      (item) => item.packingType == packingType
    )[0].subType;
    // console.log("this.subTypeArray", this.subTypeArray);
  }

  addUnits() {
    this.showUnits = true;
    let sUnit = this.unitObj.unit.split("-")[1];
    let unit = this.unitObj.unit.split("-")[0];
    this.unitsArray.push({
      quantity: this.unitObj.quantity,
      unit: unit,
      sUnit: sUnit,
    });
    // console.log("unitsArray", this.unitsArray);
    this.unitObj = {};
    this.unitForm.reset();
  }

  editUnitRowData(editIndex) {
    this.editUnitRow = [];
    this.editUnitObj = {};
    this.editUnitRow[editIndex] = true;
    this.editUnitObj = this.unitsArray[editIndex];
    this.editUnitObj.unit =
      this.unitsArray[editIndex].unit + "-" + this.unitsArray[editIndex].sUnit;
    // console.log("editUnit", this.editUnitObj)
  }

  deleteUnitRow(index) {
    // console.log("Deleted!");
    this.unitsArray.splice(index, 1);
  }

  updateUnitRow(updateIndex) {
    let sUnit = this.editUnitObj.unit.split("-")[1];
    let unit = this.editUnitObj.unit.split("-")[0];
    this.unitsArray[updateIndex].quantity = this.editUnitObj.quantity;
    this.unitsArray[updateIndex].unit = unit;
    this.unitsArray[updateIndex].sUnit = sUnit;
    // console.log("unitsArray", this.unitsArray);
    this.editUnitRow = [];
    this.editUnitObj = {};
    this.editUnitRow[updateIndex] = false;
  }

  cancelUnitRow(cancelIndex) {
    this.editUnitRow = [];
    this.editUnitObj = {};
    this.editUnitRow[cancelIndex] = false;
  }

  addTransport() {
    this.showTransportTable = true;
    this.transportArray.push({
      packingType: this.transportObj.packingType,
      subType: this.transportObj.subType,
      packingDescription: this.transportObj.packingDescription,
    });
    // console.log("transportArray", this.transportArray);
    this.transportForm.reset();
    this.transportObj = {};
    this.transportObj.subType = [];
    this.transportObj["subType"] = [];
    this.transportObj["subType"] = null;
    this.transportObj["subType"] = undefined;
    this.transportObj.subType = null;
    this.transportObj.subType = undefined;
    this.subTypeArray = [];
  }

  selectRowType(rowType, index) {
    // console.log("type", rowType);
    this.rowReadOnly = [];
    this.rowReadOnly[index] = rowType == "Textbox" ? true : false;
  }

  addHarvest() {
    this.showTable = true;
    this.harvestObj["possibleValuesArray"] =
      this.harvestObj.possibleValues.split(",");
    this.harvestArray.push({
      parameter: this.harvestObj.parameter,
      possibleValues: this.harvestObj.possibleValues,
      possibleValuesArray: this.harvestObj["possibleValuesArray"],
      type: this.harvestObj.type,
    });
    // console.log("harvestArray", JSON.stringify(this.harvestArray));
    this.harvestForm.reset();
    this.harvestObj = { parameter: "", possibleValues: "", type: "" };
  }

  editHarvestRowData(editIndex) {
    this.editHarvestRow = [];
    this.rowReadOnly = [];
    this.editHarvestRow[editIndex] = true;
    this.rowReadOnly[editIndex] =
      this.harvestArray[editIndex].type == "Textbox" ? true : false;
    this.editHarvestObj = this.harvestArray[editIndex];
    this.editHarvestObj.type = this.harvestArray[editIndex].type;
    // console.log("editHarvest", this.editHarvestObj)
  }

  deleteHarvestRow(index) {
    // console.log("Deleted!");
    this.harvestArray.splice(index, 1);
  }

  updateHarvestRow(updateIndex) {
    this.harvestArray[updateIndex].parameter = this.editHarvestObj.parameter;
    this.harvestArray[updateIndex].possibleValues =
      this.editHarvestObj.possibleValues;
    this.harvestArray[updateIndex].possibleValuesArray =
      this.editHarvestObj.possibleValues.split(",");
    // this.harvestArray[updateIndex].possibleValuesArray = this.editHarvestObj.possibleValuesArray;
    this.harvestArray[updateIndex].type = this.editHarvestObj.type;
    this.editHarvestRow = [];
    this.editHarvestRow[updateIndex] = false;
  }

  cancelHarvestRow(cancelIndex) {
    this.editHarvestRow = [];
    this.editHarvestRow[cancelIndex] = false;
  }

  editTransportRowData(editIndex) {
    this.editTransportRow = [];
    this.subTypeArray = [];
    this.editTransportRow[editIndex] = true;
    this.editTransportObj = this.transportArray[editIndex];
    this.selectPackingType(this.editTransportObj.packingType);
    // console.log("editTransport", this.editTransportObj)
  }

  deleteTransportRow(index) {
    // console.log("Transport Deleted!");
    this.transportArray.splice(index, 1);
  }

  cancelTransportRow(cancelIndex) {
    this.editTransportRow = [];
    this.subTypeArray = [];
    this.editTransportRow[cancelIndex] = false;
  }

  updateTransportRow(updateIndex) {
    this.transportArray[updateIndex].packingType =
      this.editTransportObj.packingType;
    this.transportArray[updateIndex].subType = this.editTransportObj.subType;
    this.transportArray[updateIndex].packingDescription =
      this.editTransportObj.packingDescription;
    this.editTransportRow = [];
    this.subTypeArray = [];
    this.editTransportRow[updateIndex] = false;
    // console.log("transportArray", this.transportArray);
  }

  deleteVisit(index) {
    // console.log("delete main profile array index", this.mainprofileArray[index].orderId);
    let orderid = this.mainprofileArray[index].orderId;
    this.mainprofileArray.splice(index, 1);
    this.scheduledVisitName.splice(index, 1);
    this.scheduledVisitNumber.splice(index, 1);
    this.tolerance.splice(index, 1);
    this.numberOfVisits = this.numberOfVisits - 1;
    if (this.fetchedToolList.length > 0) {
      // console.log("this.fetchedToolList ", this.fetchedToolList[0].collectionData[index], orderid, this.fetchedToolList[0].collectionData.map(function (e) { return e.orderId; }).indexOf(orderid));
      let indexOfFetchList = this.fetchedToolList[0].collectionData
        .map(function (e) {
          return e.orderId;
        })
        .indexOf(orderid);
      if (indexOfFetchList > -1) {
        // console.log("deleted...")
        this.fetchedToolList[0].collectionData.splice(indexOfFetchList, 1);
      }
    }
  }

  //click crop data button
  openCropData(content, data, index) {
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.qtnAnsArray = [];
    this.dataId = undefined;
    this.cropdataObj = {
      orderId: null,
      ask: "",
      type: "",
      response: "",
      kpi: false,
    };
    this.cropdataUpdateObj = {
      orderId: null,
      ask: "",
      type: "",
      response: "",
      kpi: false,
    };
    // console.log("fetchedToolList", this.fetchedToolList, this.mainprofileArray);
    // console.log("crop index data", this.cropdata[index]);
    if (this.fetchedToolList.length == 0) {
      this.dataId = undefined;
      this.qtnAnsArray = [
        {
          orderId: 1,
          ask: "Farm picture",
          type: "Camera",
          response: "Capture Farm Image",
          kpi: true,
          kpiName: "farmPicture",
        },
        {
          orderId: 2,
          ask: "Expected yield",
          type: "number",
          response: "Enter Expected Yield Value",
          kpi: true,
          kpiName: "expectedYield",
        },
        {
          orderId: 3,
          ask: "Expected harvest date",
          type: "date",
          response: "Select The Expected Harvest Date",
          kpi: true,
          kpiName: "harvestDate",
        },
        {
          orderId: 4,
          ask: "Crop health",
          type: "Single Select",
          response: "Completely healthy,Moderately healthy,Unhealthy",
          kpi: true,
          kpiName: "cropHealth",
        },
      ];
      if (
        this.mainprofileArray[index].cropDataId &&
        this.mainprofileArray[index].cropDataId != ""
      ) {
        // console.log("INDEX ", this.mainprofileArray[index])
        this.getCropDatafromTool(this.mainprofileArray[index]);
      }
    } else {
      // console.log("length---- ", this.fetchedToolList[0].collectionData.length, index);
      // if (this.fetchedToolList[0].collectionData.length > index) {
      // this.getCropDatafromTool(this.fetchedToolList[0].collectionData[index])
      if (
        this.mainprofileArray[index].cropDataId &&
        this.mainprofileArray[index].cropDataId != ""
      ) {
        this.getCropDatafromTool(this.mainprofileArray[index]);
      } else {
        this.dataId = undefined;
        this.qtnAnsArray = [
          {
            orderId: 1,
            ask: "Farm picture",
            type: "Camera",
            response: "Capture Farm Image",
            kpi: true,
            kpiName: "farmPicture",
          },
          {
            orderId: 2,
            ask: "Expected yield",
            type: "number",
            response: "Enter Expected Yield Value",
            kpi: true,
            kpiName: "expectedYield",
          },
          {
            orderId: 3,
            ask: "Expected harvest date",
            type: "date",
            response: "Select The Expected Harvest Date",
            kpi: true,
            kpiName: "harvestDate",
          },
          {
            orderId: 4,
            ask: "Crop health",
            type: "Single Select",
            response: "Completely healthy,Moderately healthy,Unhealthy",
            kpi: true,
            kpiName: "cropHealth",
          },
        ];
      }
    }
    this.modalService.open(content, config);
    this.cropIndex = index;
  }

  getCropDatafromTool(selectedcropdata) {
    // console.log("cropData ", selectedcropdata);
    this.insectInstruction = "";
    this.diseaseInstruction = "";
    this.weedInstruction = "";
    this.nutritionInstruction = "";
    var obj = {
      cropDataId: selectedcropdata.cropDataId,
      group: this.groupName,
    };
    this.profileService.getAllCropData(obj).then((data: any) => {
      // console.log("getAllCropData result == ", data, this.cropdata)
      if (data.length > 0) {
        const indexOfcrop = this.cropdata
          .map((e) => e.cropDataId)
          .indexOf(data[0].cropDataId);
        // console.log("index of cropDataId ", indexOfcrop);
        // if (indexOfcrop != -1) {
        //   this.qtnAnsArray = this.cropdata[indexOfcrop].cropData;
        // } else {
        this.dataId = data[0].cropDataId;
        this.qtnAnsArray = data[0].cropData;
        // }
      } else {
        this.qtnAnsArray = [
          {
            orderId: 1,
            ask: "Farm picture",
            type: "Camera",
            response: "Capture Farm Image",
            kpi: true,
            kpiName: "farmPicture",
          },
          {
            orderId: 2,
            ask: "Expected yield",
            type: "TextBox",
            response: "Enter Expected Yield Value",
            kpi: true,
            kpiName: "expectedYield",
          },
          {
            orderId: 3,
            ask: "Expected harvest date",
            type: "date",
            response: "Select The Expected Harvest Date",
            kpi: true,
            kpiName: "harvestDate",
          },
          {
            orderId: 4,
            ask: "Crop health",
            type: "Single Select",
            response: "Completely healthy,Moderately healthy,Unhealthy",
            kpi: true,
            kpiName: "cropHealth",
          },
        ];
        // console.log("cropData ", selectedcropdata);
        const indexOfCrop = this.cropdata
          .map((e) => e.cropDataId)
          .indexOf(selectedcropdata.cropDataId);
        // console.log("index of indexOfcropdata ", selectedcropdata.cropDataId, indexOfCrop);
        if (indexOfCrop != -1) {
          this.dataId = this.cropdata[indexOfCrop].cropDataId;
          this.qtnAnsArray = this.cropdata[indexOfCrop].cropData;
        }
      }
    });
  }

  //save crop data
  saveCropData() {
    this.cropDataBtnColor[this.cropIndex] = true;
    this.showmlist = true;
    if (this.dataId == undefined) {
      this.dataId = UUID.UUID();
      // console.log("this.dataId ", this.dataId);
    }
    let obj = {
      profileId: this.profileUuid,
      cropDataId: this.dataId,
      cropData: this.qtnAnsArray,
      group: this.groupName,
    };
    // console.log("obj ", obj);
    const found = this.cropdata.some((el) => el.cropDataId === this.dataId);
    console.log("found ", found);
    if (!found) {
      this.cropdata.push(obj);
    }
    //  else {
    //   this.updateCropData(obj)
    // }
    if (this.finalBtntype != "save") {
      this.updateCropData(obj);
    }
    // console.log("save cropdataobj : ", this.cropdata);
    this.mainprofileArray[this.cropIndex].cropDataId = this.dataId;
  }

  updateCropData(obj) {
    this.profileService.updateCropdata(obj).then((data: any) => {
      // console.log("crop data", data);
    });
  }

  //open POP
  openPOP(content, data, index) {
    console.log("this.pop ", this.pop[index]);
    this.popId = undefined;
    this.insectArray = [];
    this.showIList = true;
    this.diseaseArray = [];
    this.weedArray = [];
    this.nutritionArray = [];
    this.activityArray = [];
    this.practiceArray = [];
    this.insectInstruction = "";
    this.diseaseInstruction = "";
    this.weedInstruction = "";
    this.nutritionInstruction = "";
    this.insectText = false;
    this.diseaseText = false;
    this.weedText = false;
    this.nutritionText = false;
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalService.open(content, config);
    console.log("crop data index ", this.fetchedToolList, this.mainprofileArray);
    this.popIndex = index;
    if (this.fetchedToolList.length == 0) {
      this.popId = undefined;
      if (
        this.mainprofileArray[index].popId &&
        this.mainprofileArray[index].popId != ""
      ) {
        // console.log("INDEX ", this.mainprofileArray[index])
        this.getPOPfromTool(this.mainprofileArray[index]);
      }
    } else {
      // if (this.fetchedToolList[0].collectionData.length > index) {
      //   console.log("INDEX ", this.fetchedToolList[0].collectionData[index])
      //   this.getPOPfromTool(this.fetchedToolList[0].collectionData[index]);
      // }
      if (
        this.mainprofileArray[index].popId &&
        this.mainprofileArray[index].popId != ""
      ) {
        // console.log("INDEX ", this.mainprofileArray[index])
        this.getPOPfromTool(this.mainprofileArray[index]);
      } else {
        this.popId = undefined;
      }
    }
  }

  getPOPfromTool(fetchedData) {
    var obj = {
      popId: fetchedData.popId,
      group: this.groupName,
    };
    this.profileService.getAllPOP(obj).then((data: any) => {
      console.log("getAllPOP == ", data);
      console.log("getAllPOP  this.pop == ", this.pop);
      if (data.length > 0) {
        const indexOfPop = this.pop.map((e) => e.popId).indexOf(data[0].popId);
        console.log("index of pop ", indexOfPop);
        this.popId = data[0].popId;
        this.insectArray = data[0].insect.solution;
        console.log("this.insectArray", this.insectArray);
        this.insectInstruction = data[0].insect.instruction;
        this.diseaseInstruction = data[0].disease.instruction;
        this.weedInstruction = data[0].weed.instruction;
        this.nutritionInstruction = data[0].nutrition.instruction;
        // this.insectInstruction = data[0].insect.instruction
        this.diseaseArray = data[0].disease.solution;
        // this.diseaseInstruction = data[0].disease.instruction
        this.weedArray = data[0].weed.solution;
        // this.weedInstruction = data[0].weed.instruction
        this.nutritionArray = data[0].nutrition.solution;
        // this.nutritionInstruction = data[0].nutrition.instruction
        this.activityArray = data[0].activity;
        this.practiceArray = data[0].practice;
      } else {
        const indexOfPop = this.pop
          .map((e) => e.popId)
          .indexOf(fetchedData.popId);
        console.log("local index of pop ", fetchedData.popId, indexOfPop);
        if (indexOfPop != -1) {
          this.popId = this.pop[indexOfPop].popId;
          this.insectArray = this.pop[indexOfPop].insect.solution;
          this.insectInstruction = this.pop[indexOfPop].insect.instruction;
          this.diseaseInstruction = this.pop[indexOfPop].disease.instruction;
          this.weedInstruction = this.pop[indexOfPop].weed.instruction;
          this.nutritionInstruction =
            this.pop[indexOfPop].nutrition.instruction;
          // this.insectInstruction = this.pop[index].insect.instruction
          this.diseaseArray = this.pop[indexOfPop].disease.solution;
          // this.diseaseInstruction = this.pop[index].disease.instruction
          this.weedArray = this.pop[indexOfPop].weed.solution;
          // this.weedInstruction = this.pop[index].weed.instruction
          this.nutritionArray = this.pop[indexOfPop].nutrition.solution;
          // this.nutritionInstruction = this.pop[index].nutrition.instruction
          this.activityArray = this.pop[indexOfPop].activity;
          this.practiceArray = this.pop[indexOfPop].practice;
        }
      }
    });
  }

  addPOP(type) {
    console.log("ADD POP TYPE : ", type);
    this.popProduct = "";
    this.popApplication = "";
    this.popDosage = "";
    this.popPractice = "";
    this.poptype = "save";
    this.imageNameList = [];
    this.urls = [];
    this.videoName = "";
    this.videoUrl = "";
    if (type == "insect") {
      // console.log("insectArray ", this.insectArray);
      this.showIList = false;
      this.iobj = {
        product: "",
        productuuid: "",
        application: "",
        dosage: "",
        info: "",
        image: [],
        video: "",
      };
      this.windGroup.reset();
    } else if (type == "disease") {
      this.showDList = false;
      this.dobj = {
        product: "",
        productuuid: "",
        application: "",
        dosage: "",
        info: "",
        image: [],
        video: "",
      };
      this.windGroup.reset();
    } else if (type == "weed") {
      this.showWList = false;
      this.wobj = {
        product: "",
        productuuid: "",
        application: "",
        dosage: "",
        info: "",
        image: [],
        video: "",
      };
      this.windGroup.reset();
    } else if (type == "nutrition") {
      this.showNList = false;
      this.nobj = {
        product: "",
        productuuid: "",
        application: "",
        dosage: "",
        info: "",
        image: [],
        video: "",
      };
      this.windGroup.reset();
    } else if (type == "activity") {
      this.showAList = false;
      this.aobj = { application: "", image: [], video: "" };
    } else if (type == "practice") {
      this.showPList = false;
      this.pobj = { practice: "", image: [], video: "" };
    }
  }

  addInsect() {
    this.poptype = "save";
    this.showIList = false;
    this.iobj = {
      product: "",
      productuuid: "",
      application: "",
      dosage: "",
      info: "",
      image: [],
      video: "",
    };
    this.windGroup.reset();
  }

  adddisease() {
    this.poptype = "save";
    this.showDList = false;
    this.dobj = {
      product: "",
      productuuid: "",
      application: "",
      dosage: "",
      info: "",
      image: [],
      video: "",
    };
    this.windGroup.reset();
  }

  addWeed() {
    this.poptype = "save";
    this.showWList = false;
    this.wobj = {
      product: "",
      productuuid: "",
      application: "",
      dosage: "",
      info: "",
      image: [],
      video: "",
    };
    this.windGroup.reset();
  }

  addNutrition() {
    this.poptype = "save";
    this.showNList = false;
    this.nobj = {
      product: "",
      productuuid: "",
      application: "",
      dosage: "",
      info: "",
      image: [],
      video: "",
    };
    this.windGroup.reset();
  }

  addActivity() {
    this.poptype = "save";
    this.showAList = false;
    this.aobj = { application: "", image: [], video: "" };
  }

  addPractice() {
    this.poptype = "save";
    this.showPList = false;
    this.pobj = { practice: "", image: [], video: "" };
  }

  onchangetab(event) {
    // console.log("event ", event.index)
    this.showIList = true;
    this.showDList = true;
    this.showNList = true;
    this.showAList = true;
    this.showPList = true;
    this.showWList = true;
    this.getAllProducts();
    this.urls = [];
    this.videoUrl = "";
    this.videoName = "";
    this.windGroup.reset();
    this.poptype = "save";
  }

  //edit POP data..
  editPOP(type, index) {
    this.tempObject = {};
    this.poptype = "update";
    this.urls = [];
    // this.uploadFileList = [];
    this.imageNameList = [];
    this.videoUrl = "";
    this.videoName = "";
    // this.insectArray = [];
    // this.weedArray = [];
    // this.diseaseArray = [];
    // this.nutritionArray = [];
    // this.activityArray = [];
    // this.practiceArray = [];
    this.popindex = index;
    // console.log("edit data ", type);
    this.popProduct = "";
    this.popApplication = "";
    this.popDosage = "";
    this.popPractice = "";
    if (type == "insect") {
      // this.urls = this.insectArray[index].image;
      this.imageNameList = this.insectArray[index].image;
      for (var i = 0; i < this.insectArray[index].image.length; i++) {
        console.log("images : ", this.insectArray[index].image[i]);
        this.urls.push(this.globalImgUrl + this.insectArray[index].image[i]);
        console.log("urls : ", this.urls);
        // this.uploadFileList.push(this.globalImgUrl + this.insectArray[index].image[i]);
      }
      if (this.insectArray[index].video != "")
        this.videoUrl = this.globalImgUrl + this.insectArray[index].video;
      else this.videoUrl = "";
      this.videoName = this.insectArray[index].video;
      this.iobj = this.insectArray[index];
      this.popProduct = this.iobj.product;
      this.popApplication = this.iobj.application;
      this.popDosage = this.iobj.dosage;
      this.tempObject = Object.assign({}, this.insectArray[index]);
      this.showIList = false;
    } else if (type == "disease") {
      this.imageNameList = this.diseaseArray[index].image;
      for (var i = 0; i < this.diseaseArray[index].image.length; i++) {
        // console.log("images : ", this.diseaseArray[index].image[i])
        this.urls.push(this.globalImgUrl + this.diseaseArray[index].image[i]);
        // this.uploadFileList.push(this.globalImgUrl + this.diseaseArray[index].image[i]);
      }
      this.videoName = this.diseaseArray[index].video;
      if (this.diseaseArray[index].video != "")
        this.videoUrl = this.globalImgUrl + this.diseaseArray[index].video;
      else this.videoUrl = "";
      this.dobj = this.diseaseArray[index];
      this.popProduct = this.dobj.product;
      this.popApplication = this.dobj.application;
      this.popDosage = this.dobj.dosage;
      this.tempObject = Object.assign({}, this.diseaseArray[index]);
      this.showDList = false;
    } else if (type == "weed") {
      this.imageNameList = this.weedArray[index].image;
      // this.urls = this.insectArray[index].image;
      for (var i = 0; i < this.weedArray[index].image.length; i++) {
        // console.log("images : ", this.weedArray[index].image[i])
        this.urls.push(this.globalImgUrl + this.weedArray[index].image[i]);
        // this.uploadFileList.push(this.globalImgUrl + this.weedArray[index].image[i]);
      }
      this.videoName = this.weedArray[index].video;
      if (this.weedArray[index].video != "")
        this.videoUrl = this.globalImgUrl + this.weedArray[index].video;
      else this.videoUrl = "";
      this.wobj = this.weedArray[index];
      this.popProduct = this.wobj.product;
      this.popApplication = this.wobj.application;
      this.popDosage = this.wobj.dosage;
      this.tempObject = Object.assign({}, this.weedArray[index]);
      this.showWList = false;
    } else if (type == "nutrition") {
      this.imageNameList = this.nutritionArray[index].image;
      // this.urls = this.insectArray[index].image;
      for (var i = 0; i < this.nutritionArray[index].image.length; i++) {
        // console.log("images : ", this.nutritionArray[index].image[i])
        this.urls.push(this.globalImgUrl + this.nutritionArray[index].image[i]);
        // this.uploadFileList.push(this.globalImgUrl + this.nutritionArray[index].image[i]);
      }
      this.videoName = this.nutritionArray[index].video
        ? this.nutritionArray[index].video
        : "";
      if (this.nutritionArray[index].video != "")
        this.videoUrl = this.globalImgUrl + this.nutritionArray[index].video;
      else this.videoUrl = "";
      this.nobj = this.nutritionArray[index];
      this.popProduct = this.nobj.product;
      this.popApplication = this.nobj.application;
      this.popDosage = this.nobj.dosage;
      this.tempObject = Object.assign({}, this.nutritionArray[index]);
      this.showNList = false;
    } else if (type == "activity") {
      this.imageNameList = this.activityArray[index].image;
      for (var i = 0; i < this.activityArray[index].image.length; i++) {
        // console.log("images : ", this.activityArray[index].image[i])
        this.urls.push(this.globalImgUrl + this.activityArray[index].image[i]);
        // this.uploadFileList.push(this.globalImgUrl + this.activityArray[index].image[i]);
      }
      this.videoName = this.activityArray[index].video;
      // this.urls = this.insectArray[index].image;
      if (this.activityArray[index].video != "")
        this.videoUrl = this.globalImgUrl + this.activityArray[index].video;
      else this.videoUrl = "";
      this.aobj = this.activityArray[index];
      this.popApplication = this.activityArray[index].application;
      this.tempObject = Object.assign({}, this.activityArray[index]);
      this.showAList = false;
    } else if (type == "practice") {
      this.imageNameList = this.practiceArray[index].image;
      // this.urls = this.insectArray[index].image;
      for (var i = 0; i < this.practiceArray[index].image.length; i++) {
        // console.log("images : ", this.practiceArray[index].image[i])
        this.urls.push(this.globalImgUrl + this.practiceArray[index].image[i]);
        // this.uploadFileList.push(this.globalImgUrl + this.practiceArray[index].image[i]);
      }
      this.videoName = this.practiceArray[index].video;
      if (this.practiceArray[index].video != "")
        this.videoUrl = this.globalImgUrl + this.practiceArray[index].video;
      else this.videoUrl = "";
      this.pobj = this.practiceArray[index];
      this.popPractice = this.practiceArray[index].practice;
      this.tempObject = Object.assign({}, this.practiceArray[index]);
      this.showPList = false;
    }
  }

  deletePOP(type, index) {
    // console.log("deletePoP:-", type, index, this.insectArray[index])
    if (type == "insect") {
      this.insectArray.splice(index, 1);
    } else if (type == "disease") {
      this.diseaseArray.splice(index, 1);
    } else if (type == "weed") {
      this.weedArray.splice(index, 1);
    } else if (type == "nutrition") {
      this.nutritionArray.splice(index, 1);
    } else if (type == "activity") {
      this.activityArray.splice(index, 1);
    } else if (type == "practice") {
      this.practiceArray.splice(index, 1);
    }
  }

  //update Pop
  updatePOP(type) {
    this.poptype = "save";
    // console.log("updatePOP ", this.iobj)
    if (type == "insect") {
      // this.urls = this.insectArray[index].image;
      this.iobj.application = this.popApplication;
      this.iobj.dosage = this.popDosage;
      this.iobj.info = this.insectInstruction;
      // this.iobj.product = this.popProduct
      this.iobj.product = this.popProduct["technicalName"];
      this.iobj.productuuid = this.popProduct["productuuid"];
      this.iobj.image = this.iobj.image.concat(
        this.imageNameList.filter((item) => {
          return this.iobj.image.indexOf(item) < 0;
        })
      );
      this.iobj.video = this.videoName;
      this.insectArray[this.popindex] = this.iobj;
      this.showIList = true;
    } else if (type == "disease") {
      // this.urls = this.insectArray[index].image;
      this.dobj.application = this.popApplication;
      this.dobj.dosage = this.popDosage;
      this.dobj.info = this.insectInstruction;
      // this.dobj.product = this.popProduct
      this.dobj.product = this.popProduct["technicalName"];
      this.dobj.productuuid = this.popProduct["productuuid"];
      this.dobj.image = this.dobj.image.concat(
        this.imageNameList.filter((item) => {
          return this.dobj.image.indexOf(item) < 0;
        })
      );
      this.dobj.video = this.videoName;
      this.diseaseArray[this.popindex] = this.dobj;
      this.showDList = true;
    } else if (type == "weed") {
      // this.urls = this.insectArray[index].image;
      this.wobj.application = this.popApplication;
      this.wobj.dosage = this.popDosage;
      this.wobj.info = this.insectInstruction;
      // this.wobj.product = this.popProduct
      this.wobj.product = this.popProduct["technicalName"];
      this.wobj.productuuid = this.popProduct["productuuid"];
      this.wobj.image = this.wobj.image.concat(
        this.imageNameList.filter((item) => {
          return this.wobj.image.indexOf(item) < 0;
        })
      );
      this.wobj.video = this.videoName;
      this.weedArray[this.popindex] = this.wobj;
      this.showWList = true;
    } else if (type == "nutrition") {
      // this.urls = this.insectArray[index].image;
      this.nobj.application = this.popApplication;
      this.nobj.dosage = this.popDosage;
      this.nobj.info = this.insectInstruction;
      // this.nobj.product = this.popProduct
      this.nobj.product = this.popProduct["technicalName"];
      this.nobj.productuuid = this.popProduct["productuuid"];
      this.nobj.image = this.nobj.image.concat(
        this.imageNameList.filter((item) => {
          return this.nobj.image.indexOf(item) < 0;
        })
      );
      this.nobj.video = this.videoName;
      this.nutritionArray[this.popindex] = this.nobj;
      this.showNList = true;
    } else if (type == "activity") {
      // this.urls = this.insectArray[index].image;
      this.aobj.application = this.popApplication;
      this.aobj.image = this.aobj.image.concat(
        this.imageNameList.filter((item) => {
          return this.aobj.image.indexOf(item) < 0;
        })
      );
      this.aobj.video = this.videoName;
      this.activityArray[this.popindex] = this.aobj;
      this.showAList = true;
    } else if (type == "practice") {
      this.pobj.practice = this.popPractice;
      // this.urls = this.insectArray[index].image;
      this.pobj.image = this.pobj.image.concat(
        this.imageNameList.filter((item) => {
          return this.pobj.image.indexOf(item) < 0;
          // return this.aobj.image.indexOf(item) < 0;
        })
      );
      this.pobj.video = this.videoName;
      this.practiceArray[this.popindex] = this.pobj;
      this.showPList = true;
    }
    this.uploadFileToActivity();
    this.windGroup.reset();
  }

  closePOP() {
    this.showIList = true;
  }

  //save POP.
  savePOP() {
    this.showIList = true;
    console.log("savePOP this.popId ", this.popId);
    this.popBtnColor[this.popIndex] = true;
    if (this.popId == undefined) {
      this.popId = UUID.UUID();
    }
    let pop = {
      popId: this.popId,
      profileId: this.profileUuid,
      group: this.groupName,
      insect: {
        instruction: this.insectInstruction,
        solution: this.insectArray,
      },
      disease: {
        instruction: this.diseaseInstruction,
        solution: this.diseaseArray,
      },
      weed: {
        instruction: this.weedInstruction,
        solution: this.weedArray,
      },
      nutrition: {
        instruction: this.nutritionInstruction,
        solution: this.nutritionArray,
      },
      activity: this.activityArray,
      practice: this.practiceArray,
    };
    console.log("pop", pop);
    console.log("this.pop", this.pop);
    const found = this.pop.some((el) => el.popId === this.popId);
    console.log("found ", found);
    if (!found) {
      this.pop.push(pop);
    } else {
      console.log("this.newpop ", JSON.stringify(pop));
    }
    console.log("finalBtntype", this.finalBtntype);
    console.log("this.newpop ", JSON.stringify(pop));
    if (this.finalBtntype != "save") {
      this.updatePOPData(pop);
    }
    this.mainprofileArray[this.popIndex].popId = this.popId;
  }

  updatePOPData(pop) {
    this.profileService.updatePOP(pop).then((data: any) => {
      console.log("pop data", data);
    });
  }

  //Open health dia model
  openHealthDiagonsis(content, data, index) {
    this.healthRowId = undefined;
    this.showHealthForms = false;
    console.log("this.healthArray ", this.healthdiagnosis[index]);
    this.healthDiagnosisIndex = index;
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      // size:'lg'
    };
    this.modalService.open(content, config);
    this.getAllCrops();
    this.onChangeHealthCropName();
    this.editHealth = [];
    console.log(
      "crop data index ",
      this.fetchedToolList,
      this.mainprofileArray
    );
    this.healthArray = [];
    this.healthDiagnosisFormGroup.reset();
    this.healthObj = {
      name: "",
      healthId: "",
      cropName: "",
      description: "",
      images: [],
      recommLow: "",
      recommMedium: "",
      recommHigh: "",
      group: "",
    };
    if (this.fetchedToolList.length == 0) {
      this.healthRowId = undefined;
      if (
        this.mainprofileArray[index].healthDiagnosisId &&
        this.mainprofileArray[index].healthDiagnosisId != ""
      ) {
        console.log("INDEX ", this.mainprofileArray[index]);
        this.getHealthfromTool(this.mainprofileArray[index]);
      }
    } else {
      if (
        this.mainprofileArray[index].healthDiagnosisId &&
        this.mainprofileArray[index].healthDiagnosisId != ""
      ) {
        console.log("INDEX ", this.mainprofileArray[index]);
        this.getHealthfromTool(this.mainprofileArray[index]);
        // if (this.fetchedToolList[0].collectionData.length > index) {
        //   this.getHealthfromTool(this.fetchedToolList[0].collectionData[index]);
      } else {
        this.healthRowId = undefined;
      }
    }
  }

  getHealthfromTool(fetchedHealth) {
    console.log("getHealthfromTool ", fetchedHealth);
    this.healthArray = [];
    console.log("getHealthfromTool ", fetchedHealth);
    var obj = {
      healthDiagnosisId: fetchedHealth.healthDiagnosisId,
      group: this.groupName,
    };
    this.profileService.getAllHealth(obj).then((data: any) => {
      console.log("getAllHealth == ", data);
      if (data.length > 0) {
        const indexOfHealth = this.healthdiagnosis
          .map((e) => e.healthDiagnosisId)
          .indexOf(data[0].healthDiagnosisId);
        this.healthRowId = data[0].healthDiagnosisId;
        this.healthArray = data[0].healthCollection;
      } else {
        const indexOfHealth = this.healthdiagnosis
          .map((e) => e.healthDiagnosisId)
          .indexOf(fetchedHealth.healthDiagnosisId);
        console.log("index of indexOfHealth ", indexOfHealth);
        if (indexOfHealth != -1) {
          this.healthRowId =
            this.healthdiagnosis[indexOfHealth].healthDiagnosisId;
          this.healthArray =
            this.healthdiagnosis[indexOfHealth].healthCollection;
        }
      }
    });
  }

  //check health.
  selectHealth(index, ischecked) {
    // console.log("selectHealth ", index, ischecked, this.healthdiagnosisList[(this.page - 1) + index].healthId, this.healthdiagnosisArray.length);
    // let healthId = this.healthdiagnosisList[(this.page - 1) * 15 + index].healthId;
    let healthId = this.healthdiagnosisList[index].healthId;
    if (ischecked) {
      // console.log(this.healthArray.some(id => id.healthId == healthId))
      // if (!this.healthArray.some(id => id.healthId == healthId)) {
      //   let obj = {
      //     healthId: this.healthdiagnosisList[(this.page - 1) * 15 + index].healthId,
      //   }
      //   this.healthArray.push(obj);
      // }
      let obj = {
        healthId: this.healthdiagnosisList[index].healthId,
      };
      this.healthArray.push(obj);
    } else {
      for (var i = 0; i < this.healthArray.length; i++) {
        if (this.healthArray[i].healthId == healthId) {
          console.log("selectHealth.... ", this.healthArray[i].healthId);
          this.healthArray.splice(i, 1);
          break;
        }
      }
    }
    console.log("this.healthArray ", this.healthArray);
  }

  //save health diagnosis.
  submitHealthDiagnosis() {
    console.log("@@Health row id:", this.healthRowId);
    this.healthBtnColor[this.healthDiagnosisIndex] = true;
    this.editHealth = [];
    this.showHList = true;
    this.showHealthForms = false;
    if (this.healthRowId == undefined) {
      this.healthRowId = UUID.UUID();
    }
    let obj = {
      profileId: this.profileUuid,
      healthDiagnosisId: this.healthRowId,
      healthCollection: this.healthArray,
      group: this.groupName,
    };
    const found = this.healthdiagnosis.some(
      (el) => el.healthDiagnosisId === this.healthRowId
    );
    console.log("found ", found, obj);
    if (!found) {
      this.healthdiagnosis.push(obj);
    }
    if (this.finalBtntype != "save") {
      this.updateHealthDiagnosis(obj);
    }
    console.log("HEALTH ARRAY : ", this.healthArray, obj);
    this.mainprofileArray[this.healthDiagnosisIndex].healthDiagnosisId =
      this.healthRowId;
    this.imageNameList = [];
    this.urls = [];
  }

  updateHealthDiagnosis(obj) {
    this.profileService.updateHealthCollection(obj).then((data: any) => {
      console.log("health data", data);
      this.healthPreviousPage = null;
    });
  }

  //open health library
  healthinput(content) {
    this.showHealthForms = true;
    // let config: NgbModalOptions = {
    //   backdrop: 'static',
    //   keyboard: false,
    //   // size: 'lg'
    // };
    // this.modalService.open(content, config);
  }

  getAllCrops() {
    this.cropNameList = [];
    var options = {
      group: this.groupName,
    };
    this.cropsService.getCropData(options).then((data: any) => {
      console.log("cropData == ", data);
      for (var i = 0; i < data.length; i++) {
        this.cropNameList.push(data[i].cropName);
      }
    });
  }

  addInstruction(type) {
    if (type == "insect") {
      this.insectText = true;
    } else if (type == "disease") {
      this.diseaseText = true;
    } else if (type == "weed") {
      this.weedText = true;
    } else if (type == "nutrition") {
      this.nutritionText = true;
    }
  }

  onChangeCategory(catagory) {
    this.cropNameList = [];
    let obj = {
      group: this.groupName,
      cropCategory: catagory,
    };
    console.log("catagory : ", catagory);
    this.cropsService.getCropByCategory(obj).then((data: any) => {
      console.log("crop data", data);
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          this.cropNameList.push(data[i].cropName);
        }
      } else {
        this.cropFormGroup.reset();
        Swal.fire("Error", "Crop Name not found", "error");
      }
    });
  }

  getAllProducts() {
    this.productList = [];
    let obj = {
      group: this.groupName,
    };
    this.profileService.getAllProducts(obj).then((data: any) => {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          let obj = {
            technicalName: data[i].technicalName,
            productuuid: data[i].productuuId,
          };
          // this.productList.push(data[i].tradeName);
          this.productList.push(obj);
        }
      } else {
        this.productList = [];
      }
    });
  }

  changedHealthDiag123() {
    this.showHealthForms = false;
    console.log("return");
    this.onChangeHealthCropName();
  }

  onChangeHealthCropName() {
    this.checkList = [];
    this.page = 1;
    this.healthdiagnosisArray = [];
    console.log(
      "onChangeHealthCropName cropid : ",
      this.mainCropID,
      this.healthDiagnosisIndex
    );
    let obj = {
      group: this.groupName,
      maincropId: this.mainCropID,
    };
    this.cropsService.getCropData(obj).then((data: any) => {
      console.log("crop data : ", data);
      if (data.length != 0) {
        this.loading = true;
        console.log("maincropId : ", data[0].maincropId);
        let cropObj = {
          group: this.groupName,
          maincropId: data[0].maincropId,
        };
        console.log("options : ", cropObj);
        this.profileService.getHealthLib(cropObj).then((data: any) => {
          console.log("healthdiagnosis : ", data);
          if (data.length > 0) {
            this.healthdiagnosisArray = data;
            this.healthCollectionSize = data.length;
            this.healthIdList = [];
            this.healthdiagnosisArray.forEach((element) => {
              this.healthIdList.push(element.healthId);
              this.checkList.push(false);
            });
            console.log("heALTH RESULT : ", data, this.healthArray);
            console.log(
              "heALTH RESULT 123: ",
              this.healthIdList,
              this.healthdiagnosisArray
            );
            this.loadHealthData(0);
            // if (this.healthArray.length > 0) {
            //   for (let health of this.healthArray) {
            //     let index = this.healthIdList.indexOf(health.healthId);
            //     console.log("healthIdList.indexOf(health) ", this.healthIdList.indexOf(health.healthId), index);
            //     this.checkList[index] = true;
            //     // this.healthdiagnosisArray[index].checked = true
            //     // if(this.healthArray[index].healthId == health.healthId) {
            //     // }
            //   }
            // }
            console.log("healthIdList ", this.healthIdList);
            console.log("this.healthdiagnosis[index] ", this.healthArray);
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
      }
    });
  }

  loadhealthPage(pageNumber: number) {
    this.loading = true;
    console.log("load", this.healthPreviousPage, pageNumber);
    if (pageNumber !== this.healthPreviousPage) {
      this.healthSkip = pageNumber * 15 - 15;
      this.healthPreviousPage = pageNumber;
      this.loadHealthData(this.healthSkip);
      console.log("healthSkip", this.healthSkip);
      console.log("pageNumber", pageNumber);
      console.log("this.previousPage", this.previousPage);
    }
  }

  loadHealthData(skip) {
    console.log("skip123 ", skip);
    this.healthdiagnosisList = [];
    for (var i = skip; i < this.healthdiagnosisArray.length; i++) {
      if (i < skip + 15) {
        this.healthdiagnosisArray[i].checked = false;
        if (this.healthArray.length > 0) {
          for (let health of this.healthArray) {
            let index = this.healthIdList.indexOf(health.healthId);
            console.log(
              "healthIdList.indexOf(health) ",
              this.healthIdList.indexOf(health.healthId),
              index
            );
            // this.healthdiagnosisList[index].checked = true;

            this.checkList[health.healthId] = true;
            // this.healthdiagnosisArray[index].checked = true
            // if(this.healthArray[index].healthId == health.healthId) {
            // }
          }
        }
        this.healthdiagnosisList.push(this.healthdiagnosisArray[i]);
      }
    }
    this.loading = false;
    console.log("healthdiagnosisList: ", this.healthdiagnosisList);
  }

  changedHealthDiag() {
    setTimeout(() => {
      this.onChangeHealthCropName();
    }, 1000);
  }

  editHealthdiagnosis(index) {
    console.log("edit ", index);
    this.editHealth = [];
    this.editHealth[index] = true;
  }

  cancelHealth(index) {
    this.editHealth = [];
    this.editHealth[index] = false;
    this.healthDiagnosisFormGroup.reset();
  }

  // EditRecom(index, obj) {
  //   console.log("healthObj ", obj, this.healthArray[index]);
  //   let healthId = this.healthdiagnosisArray[index].healthId;
  //   for (var i = 0; i < this.healthArray.length; i++) {
  //     console.log("for ");
  //     if (this.healthArray[i].healthId == healthId) {
  //       console.log("selectHealth.... ", this.healthArray[i].healthId);
  //       this.editHealth[index] = false;
  //       this.healthArray[i]['recommLow'] = obj.recommLow
  //       this.healthArray[i]['recommMedium'] = obj.recommMedium
  //       this.healthArray[i]['recommHigh'] = obj.recommHigh
  //       this.healthDiagnosisFormGroup.reset();
  //       console.log("healthArray.; ", this.healthArray);
  //       break;
  //     } else {
  //       console.log(".. else ")
  //     }
  //   }
  // }

  closeHealth() {
    this.healthPreviousPage = null;
    this.showHealthForms = false;
    this.editHealth = [];
    this.healthDiagnosisFormGroup.reset();
  }

  editInstruction(type) {
    if (type == "insect") {
      this.insectText = false;
    } else if (type == "disease") {
      this.diseaseText = false;
    } else if (type == "weed") {
      this.weedText = false;
    } else if (type == "nutrition") {
      this.nutritionText = false;
    }
  }

  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  handleInput(e) {
    // console.log("event.which ", e)
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
  saveInsect() {
    this.showIList = true;
    console.log("this.imageNameList : ", this.iobj, this.imageNameList);
    this.iobj.image = this.imageNameList;
    this.iobj.video = this.videoName;
    // this.iobj.product = this.popProduct;
    this.iobj.product = this.popProduct["technicalName"];
    this.iobj.productuuid = this.popProduct["productuuid"];
    this.iobj.application = this.popApplication;
    this.iobj.dosage = this.popDosage;
    this.wind = this.iobj;
    // this.wind.image = this.imageNameList;
    this.insectArray.push(this.wind);
    this.imageNameList = [];
    this.urls = [];
    this.videoName = "";
    this.videoUrl = "";
    this.uploadFileToActivity();
    this.windGroup.reset();
  }

  savedisease() {
    this.showDList = true;
    this.dobj.image = this.imageNameList;
    this.dobj.video = this.videoName;
    this.dobj.product = this.popProduct["technicalName"];
    this.dobj.productuuid = this.popProduct["productuuid"];
    // this.dobj.product = this.popProduct;
    this.dobj.application = this.popApplication;
    this.dobj.dosage = this.popDosage;
    this.wind = this.dobj;
    // this.wind.image = this.imageNameList;
    this.diseaseArray.push(this.wind);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = "";
    this.videoName = "";
    this.uploadFileToActivity();
    this.windGroup.reset();
  }

  saveWeed() {
    this.showWList = true;
    this.wobj.image = this.imageNameList;
    this.wobj.video = this.videoName;
    this.wobj.product = this.popProduct["technicalName"];
    this.wobj.productuuid = this.popProduct["productuuid"];
    // this.wobj.product = this.popProduct;
    this.wobj.application = this.popApplication;
    this.wobj.dosage = this.popDosage;
    this.wind = this.wobj;
    // this.wind.image = this.imageNameList;
    this.weedArray.push(this.wind);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = "";
    this.videoName = "";
    this.uploadFileToActivity();
    this.windGroup.reset();
  }

  saveNutrition() {
    this.showNList = true;
    this.nobj.image = this.imageNameList;
    this.nobj.video = this.videoName;
    this.nobj.product = this.popProduct["technicalName"];
    this.nobj.productuuid = this.popProduct["productuuid"];
    // this.nobj.product = this.popProduct;
    this.nobj.application = this.popApplication;
    this.nobj.dosage = this.popDosage;
    this.wind = this.nobj;
    // this.wind.image = this.imageNameList;
    this.nutritionArray.push(this.wind);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = "";
    this.videoName = "";
    this.uploadFileToActivity();
    this.windGroup.reset();
  }

  saveActivity() {
    this.showAList = true;
    this.aobj.image = this.imageNameList;
    this.aobj.video = this.videoName;
    this.aobj.application = this.popApplication;
    this.activity = this.aobj;
    // this.activity.image = this.imageNameList;
    this.activityArray.push(this.activity);
    this.urls = [];
    this.imageNameList = [];
    this.videoName = "";
    this.videoUrl = "";
    this.uploadFileToActivity();
    this.windGroup.reset();
  }

  savePractice() {
    this.showPList = true;
    this.pobj.image = this.imageNameList;
    this.pobj.video = this.videoName;
    this.pobj.practice = this.popPractice;
    this.practice = this.pobj;
    // this.practice.image = this.imageNameList;
    this.practiceArray.push(this.practice);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = "";
    this.videoName = "";
    this.uploadFileToActivity();
    this.windGroup.reset();
  }

  aveIndividualHealth() { }

  back(type) {
    console.log("this.tempObject ", this.tempObject);
    if (type == "insect") {
      this.iobj = Object.assign({}, this.tempObject);
      console.log("this.iobj ", this.iobj);
      this.showIList = true;
    } else if (type == "disease") {
      this.showDList = true;
      this.dobj = this.tempObject;
    } else if (type == "nutrition") {
      this.showNList = true;
      this.nobj = this.tempObject;
    } else if (type == "weed") {
      this.showWList = true;
      this.wobj = this.tempObject;
    } else if (type == "activity") {
      this.showAList = true;
      this.aobj = this.tempObject;
    } else if (type == "practice") {
      this.showPList = true;
      this.pobj = this.tempObject;
    }
    this.windGroup.reset();
  }

  //select image
  imageInput(event, type) {
    console.log("type : ", type);
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length;
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split("/")[0] == "image") {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
            if (type == "insect") {
              this.insectImgList.push(event.target.result);
            } else if (type == "disease") {
              this.diseaseImgList.push(event.target.result);
            } else if (type == "weed") {
              this.weedImgList.push(event.target.result);
            } else if (type == "nutrition") {
              this.nutritionImgList.push(event.target.result);
            } else if (type == "activity") {
              this.activityImgList.push(event.target.result);
            } else if (type == "practice") {
              this.practiceImgList.push(event.target.result);
            }
          };
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService =
            type +
            "_" +
            iuuid +
            "." +
            event.target.files.item(0).type.split("/")[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set("file", event.target.files[i], this.imageUploadService);
          formData.append("name", this.imageUploadService);
          this.uploadFileList.push(formData);
        }
      }
    }
  }

  //select video
  videoInput(event, type) {
    this.videoUrl = "";
    this.videoName = "";
    console.log("videoInput", event.target.files.item(0).type);
    // this.videoUrl=event.target.files[0].name;
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type.split("/")[0] == "video") {
        var fileLength = event.target.files.length;
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.videoUrl = event.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
        let iuuid = UUID.UUID();
        this.videoName =
          type +
          "_" +
          iuuid +
          "." +
          event.target.files.item(0).type.split("/")[1];
        // this.imageNameList.push(this.imageUploadService);
        this.videoList.push(this.videoName);
        // this.videoArray.push(event.target.files[0])
        const formData: FormData = new FormData();
        formData.set("file", event.target.files[0], this.videoName);
        formData.append("name", this.videoName);
        this.videoArray.push(formData);
        // this.iobj.video = videoUrl;
      }
    }
  }

  //upload images to aws.
  uploadFileToActivity() {
    console.log("Image array List : ", this.uploadFileList);
    for (var i = 0; i < this.uploadFileList.length; i++) {
      // this.fileUploadService.uploadFileTos3(this.uploadFileList[i]).then(data => {
      // }, error => {
      //   console.log(error);
      // });
      this.fileUploadService.uploadMultipleFiles(
        this.uploadFileList[i],
        this.imageUploadService
      );
    }
  }

  //upload video to aws.
  uploadVideo() {
    for (var i = 0; i < this.videoArray.length; i++) {
      // this.fileUploadService.uploadFileTos3(this.videoArray[i]).then(data => {
      // }, error => {
      //   console.log(error);
      // });
      this.fileUploadService.uploadMultipleFiles(
        this.videoArray[i],
        this.imageUploadService
      );
    }
  }

  //delete selected image
  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
    console.log("deleteImage ", this.imageNameList);
  }

  close() {
    this.showmlist = true;
  }

  insertIntoTable() {
    this.showmlist = false;
    console.log("insertIntoTable : ", this.cropdataObj);
    if (this.cropdataObj.kpi && this.cropdataObj.kpi == true) {
      if (
        this.kpiName != null &&
        this.kpiName != "" &&
        this.kpiName != undefined
      ) {
        this.cropdataObj["kpiName"] = this.kpiName;
        let index = this.qtnAnsArray.findIndex(
          (x) => x.orderId == this.cropdataObj.orderId
        );
        if (index === -1) {
          this.qtnAnsArray.push(this.cropdataObj);
          console.log("qtnAnsArray : ", this.qtnAnsArray);
          this.qtnAnsArray.sort(
            (a, b) => Number(a.orderId) - Number(b.orderId)
          );
          console.log("this.qtnAnsArray sorted ", this.qtnAnsArray);
          this.cropdataObj = {
            orderId: null,
            ask: "",
            type: "",
            response: "",
            kpi: false,
          };
          this.cropDataGroup.reset();
          this.showKpiName = false;
        } else {
          Swal.fire("Error", "Order Id is already exist", "error");
        }
      } else {
        Swal.fire("Add kpi name");
      }
    } else {
      let index = this.qtnAnsArray.findIndex(
        (x) => x.orderId == this.cropdataObj.orderId
      );
      if (index === -1) {
        this.qtnAnsArray.push(this.cropdataObj);
        console.log("qtnAnsArray : ", this.qtnAnsArray);
        this.qtnAnsArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
        console.log("this.qtnAnsArray sorted ", this.qtnAnsArray);
        this.cropdataObj = {
          orderId: null,
          ask: "",
          type: "",
          response: "",
          kpi: false,
        };
        this.cropDataGroup.reset();
        this.showKpiName = false;
      } else {
        Swal.fire("Error", "Order Id is already exist", "error");
      }
    }
  }

  editRowData(index) {
    this.cropdataUpdateObj = {
      orderId: null,
      ask: "",
      type: "",
      response: "",
      kpi: false,
    };
    this.cropDataGroup.reset();
    this.editRow = [];
    this.editRow[index] = true;
    this.cropdataUpdateObj.orderId = this.qtnAnsArray[index].orderId;
    this.cropdataUpdateObj.ask = this.qtnAnsArray[index].ask;
    this.cropdataUpdateObj.kpi = this.qtnAnsArray[index].kpi;
    // if (this.cropdataUpdateObj.kpi && this.cropdataUpdateObj.kpi == true) {
    //   this.cropdataUpdateObj['kpiName'] = this.qtnAnsArray[index].kpiName;
    // }
    this.cropdataUpdateObj.response = this.qtnAnsArray[index].response;
    this.cropdataUpdateObj.type = this.qtnAnsArray[index].type;
  }

  cancelRowEdit(index) {
    this.editRow = [];
    this.editRow[index] = false;
  }

  onChangeKpi(event) {
    console.log("d ", event);
    if (event.currentValue) {
      this.showKpiName = true;
    } else this.showKpiName = false;
  }

  updateRow(index) {
    console.log("this.registerFormUpdateObj ", this.cropdataUpdateObj);
    let i = this.qtnAnsArray.findIndex(
      (x) => x.orderId == this.cropdataUpdateObj.orderId
    );
    console.log("index: ", index, i);
    if (i === index) {
      this.editRow = [];
      this.editRow[index] = false;
      this.qtnAnsArray[index] = this.cropdataUpdateObj;
      this.qtnAnsArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
      this.cropdataUpdateObj = {
        orderId: null,
        ask: "",
        type: "",
        response: "",
        kpi: false,
      };
    } else if (i === -1) {
      this.editRow = [];
      this.editRow[index] = false;
      this.qtnAnsArray[index] = this.cropdataUpdateObj;
      this.qtnAnsArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
      this.cropdataUpdateObj = {
        orderId: null,
        ask: "",
        type: "",
        response: "",
        kpi: false,
      };
    } else {
      Swal.fire("Error", "Order Id is already exist", "error");
    }
  }

  deleteRow(index) {
    console.log("Deleted!");
    this.qtnAnsArray.splice(index, 1);
  }

  // //get all health diagnosis from db.
  // getAllHealthLib() {
  //   this.loading = true;
  //   this.healthArray = [];
  //   this.toolService.getAllHealthLib(this.groupName).then((data: any) => {
  //     console.log("toolService result ", JSON.stringify(data))
  //     this.healthArray = data;
  //     this.loading = false;
  //   })
  // }

  submitHealth() {
    this.healthObj.healthId = UUID.UUID();
    this.healthObj.images = this.imageNameList;
    this.healthObj.group = this.groupName;
    this.individualHealth = this.healthObj;
    this.uploadFileToActivity();
    this.profileService
      .postHealthdiagnosis(this.individualHealth)
      .then((data: any) => {
        console.log("healthfinal data", data);
        if (data) {
          this.healthDiagnosisFormGroup.reset();
          this.imageNameList = [];
          this.urls = [];
          this.showHList = true;
          // this.getAllHealthLib();
        } else {
          Swal.fire(
            "Error",
            "Data not Submitted (please contact admin)",
            "error"
          );
        }
      });
  }

  //broken image replacement
  onImgError(event) {
    event.target.src = this.globalImgUrl + "agri_logo.png";
  }

  //POST profile to db.
  SubmitProfile() {
    console.log(
      "Filled list array ",
      this.popBtnColor,
      this.cropDataBtnColor,
      this.healthBtnColor
    );
    if (
      this.cropDataBtnColor.includes(false) ||
      this.popBtnColor.includes(false) ||
      this.healthBtnColor.includes(false)
    ) {
      this.fobj.status = "INPROGRESS";
    } else {
      this.fobj.status = "COMPLETED";
    }
    this.fobj.collectionData = this.mainprofileArray;
    this.cropDataTool = this.fobj;
    console.log("Profile Json ", JSON.stringify(this.cropDataTool));
    this.uploadFileToActivity();
    this.uploadVideo();
    //submit Array of POP data
    this.pop.forEach((element) => {
      this.profileService.postPOP(element).then((data: any) => {
        console.log("pop data", data);
      });
    });
    //submit Array of crop data
    this.cropdata.forEach((element) => {
      this.profileService.postCropdata(element).then((data: any) => {
        console.log("crop data", data);
      });
    });
    //submit Array of Health
    this.healthdiagnosis.forEach((element) => {
      this.profileService.postHealthCollection(element).then((data: any) => {
        console.log("crop data", data);
      });
    });
    this.profileService.postProfile(this.cropDataTool).then((data: any) => {
      console.log("Profile data : ", data);
    });
    // this.toolService.postHealthCollection(this.healthdiagnosis).then((data: any) => {
    //   console.log("healthfinal data", data);
    // });
    setTimeout(() => {
      this.urls = [];
      this.imageNameList = [];
      this.videoList = [];
      this.videoArray = [];
      this.cropFormGroup.reset();
      // this.showStepper = !this.showStepper;
      this.showStepper = "varieties";
      this.getVarietiesByCrop(0, this.selectedCrop);
      this.cropdata = [];
      this.healthdiagnosis = [];
      this.uploadFileList = [];
      this.videoName = "";
      this.pop = [];
      this.insectInstruction = "";
      this.diseaseInstruction = "";
      this.weedInstruction = "";
      this.nutritionInstruction = "";
    }, 100);
  }

  deleteVideo() {
    this.videoUrl = "";
    this.videoName = "";
  }

  updateProfile() {
    this.dataSubmitingload = true;
    console.log(
      "Filled list array ",
      this.popBtnColor,
      this.cropDataBtnColor,
      this.healthBtnColor
    );
    // console.log("check ",this.cropDataBtnColor.includes(false),this.popBtnColor.includes(false),this.healthBtnColor.includes(false))
    if (
      this.cropDataBtnColor.includes(false) ||
      this.popBtnColor.includes(false) ||
      this.healthBtnColor.includes(false)
    ) {
      this.fobj.status = "INPROGRESS";
    } else {
      this.fobj.status = "COMPLETED";
    }
    this.fobj.collectionData = this.mainprofileArray;
    // this.fobj.status = status;
    this.cropDataTool = this.fobj;
    console.log("update Profile Json ", JSON.stringify(this.cropDataTool));
    this.uploadFileToActivity();
    this.uploadVideo();
    //submit Array of POP data
    // this.pop.forEach(element => {
    //   console.log("POP ", element)

    //   this.toolService.updatePOP(element).then((data: any) => {
    //     console.log("pop data", data);
    //   })
    // });
    //submit Array of crop data
    // this.cropdata.forEach(element => {
    //   console.log("updateCropdata ", element)
    //   this.toolService.updateCropdata(element).then((data: any) => {
    //     console.log("crop data", data);
    //   })
    // });
    //submit Array of Health
    // this.healthdiagnosis.forEach(element => {
    //   console.log("updateHealthCollection ", element)
    //   this.toolService.updateHealthCollection(element).then((data: any) => {
    //     console.log("health data", data);
    //   })
    // });
    console.log("Profile ", this.cropDataTool.collectionData);
    this.profileService.updateProfile(this.cropDataTool).then((data: any) => {
      console.log("Profile data last : ", data);
    });
    setTimeout(() => {
      this.dataSubmitingload = false;
      this.urls = [];
      this.imageNameList = [];
      this.videoList = [];
      this.videoArray = [];
      // this.cropFormGroup.reset();
      // this.showStepper = !this.showStepper;
      this.showStepper = "varieties";
      this.getVarietiesByCrop(0, this.selectedCrop);
      this.cropdata = [];
      this.healthdiagnosis = [];
      this.pop = [];
      this.insectInstruction = "";
      this.diseaseInstruction = "";
      this.weedInstruction = "";
      this.nutritionInstruction = "";
    }, 500);
    // this.toolService.postHealthCollection(this.healthdiagnosis).then((data: any) => {
    //   console.log("healthfinal data", data);
    // });
  }

  searchByName() {
    if (this.searchStr != "") {
      var obj = {
        group: this.groupName,
        field: "varietyName",
        text: this.searchStr,
        tableName: "cropvarieties",
      };
      console.log("search obj : ", obj);
      this.cropsService.getcropvarietiesRegex(obj).then((data: any) => {
        console.log("searched", data);
        this.searchStr = "";
        this.varietyArray = [];
        if (data.length > 0) {
          this.varietyArray = data;
          this.showsearchdata = false;
          console.log("varietyArray", this.varietyArray);
        } else {
          this.showsearchdata = false;
        }
      });
    }
  }
}
// //POST profile to db.
// savePartialProfile() {
//   if (this.mainprofileArray.length > 0) {
//     this.fobj.collectionData = this.mainprofileArray;
//     this.fobj.status = 'INPROGRESS';
//     this.cropDataTool = this.fobj;
//     console.log("Profile Json ", JSON.stringify(this.cropDataTool));
//     this.uploadFileToActivity();
//     this.uploadVideo();
//     //submit Array of POP data
//     this.pop.forEach(element => {
//       this.toolService.postPOP(element).then((data: any) => {
//         console.log("pop data", data);
//       })
//     });
//     //submit Array of crop data
//     this.cropdata.forEach(element => {
//       this.toolService.postCropdata(element).then((data: any) => {
//         console.log("crop data", data);
//       })
//     });
//     //submit Array of Health
//     this.healthdiagnosis.forEach(element => {
//       this.toolService.postHealthCollection(element).then((data: any) => {
//         console.log("crop data", data);
//       })
//     });
//     this.toolService.postProfile(this.cropDataTool).then((data: any) => {
//       console.log("Profile data : ", data);
//     })
//     // this.toolService.postHealthCollection(this.healthdiagnosis).then((data: any) => {
//     //   console.log("healthfinal data", data);
//     // });
//     this.urls = [];
//     this.imageNameList = [];
//     this.fileObjArray = [];
//     this.videoList = [];
//     this.videoArray = [];
//     this.cropFormGroup.reset();
//     this.showStepper = !this.showStepper;
//     this.cropdata = [];
//     this.healthdiagnosis = [];
//     this.pop = [];
//   }
// }
